import type { TClinic } from 'src/services/api/api.types';

type TProps = {
    locations: TClinic[];
    selectedClinicId?: number | string;
    userClinicId?: number | string;
    geoIpCountry?: string | null;
};

const getAvailableBookingLocations = (locations: TClinic[]): TClinic[] =>
    locations.filter(
        (location) => location.active !== false && location.showInOnlineBookings !== false
    );

const getClinicById = (
    locations: TClinic[],
    clinicId?: number | string
): TClinic | undefined => {
    if (!clinicId) return undefined;

    return locations.find((location) => `${location.id}` === `${clinicId}`);
};

const getClinicByCountryCode = (
    locations: TClinic[],
    countryCode?: string | null
): TClinic | undefined => {
    if (!countryCode) return undefined;

    return locations.find((location) => location.countryCode === countryCode);
};

const resolveInitialBookingClinic = ({
    locations,
    selectedClinicId,
    userClinicId,
    geoIpCountry
}: TProps): TClinic | undefined => {
    const availableBookingLocations = getAvailableBookingLocations(locations);

    return (
        // Preserve explicit clinic choices before falling back to booking defaults.
        getClinicById(locations, userClinicId) ??
        getClinicById(locations, selectedClinicId) ??
        getClinicByCountryCode(availableBookingLocations, geoIpCountry) ??
        getClinicByCountryCode(availableBookingLocations, 'GB') ??
        availableBookingLocations[0]
    );
};

export default resolveInitialBookingClinic;
